import { Alert, Button, Menu } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { useUpgrade } from '#components/Modals'
import { PaidFeatureNote } from '#components/Settings/Org/PaidFeatureNote'
import { PaidFeature, STRIPE_TIER } from '#components/Settings/Org/plans'
import { usePaidNote } from '#components/Settings/Org/useBillingPlan'
import { useMst } from '#state'

export const PaidMenuNote = observer(function PaidMenuNote({
  features,
}: {
  features: PaidFeature[]
}) {
  const { currentOrg } = useMst()
  const { pending, upgrade } = useUpgrade()
  const note = usePaidNote(currentOrg, features)

  if (!currentOrg || !note) return null

  return (
    <>
      <Menu.Divider />
      <Alert bg="var(--mantine-primary-color-0)" p={10} w="100%" maw={250}>
        <PaidFeatureNote
          features={note.features}
          plans={note.plans}
          fz={15}
          c="var(--mantine-primary-color-8)"
          action={
            <Button
              size="xs"
              loading={pending}
              onClick={() => upgrade(currentOrg)}
            >
              {currentOrg.tier === STRIPE_TIER
                ? 'Manage Plan'
                : 'Request upgrade'}
            </Button>
          }
        />
      </Alert>
    </>
  )
})
